module.exports = __webpack_public_path__ + "static/gisela-Normal-a6a0b2bf778b3cceb986fbfb2b20a8bc.jpg";